export default "__VITE_ASSET__7zhNT1oC__$_?nuxt_component=async&nuxt_component_name=IconFunctionIconsHerausnehmbarePads&nuxt_component_export=default__"